export default "__VITE_ASSET__991e5724__"